import type { UnknownAction } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';
import { userSlice, usersSlice } from './users';
import { customerSlice, customersSlice } from './customers';
import { supplierSlice, suppliersSlice } from './suppliers';
import { scheduledValueSlice, scheduledValuesSlice } from './scheduledValues';
import { skillSlice, skillsSlice } from './skills';
import { typeOfPaymentSlice, typeOfPaymentsSlice } from './typeOfPayments';
import { resourceSlice, resourcesSlice } from './resources';
import { resourceSkillSlice, resourceSkillsSlice } from './resourceSkills';
import { jobSlice, jobsSlice } from './jobs';
import { orderSlice, ordersSlice } from './orders';
import { activitiesSlice, activitySlice } from './activities';
import { timesheetSlice, timesheetsSlice } from './timesheets';
import { globalErrorsSlice } from './globalErrors';
import { timesheetLockSlice, timesheetLocksSlice } from './timesheetLocks';
import { orderCounterSlice, orderCountersSlice } from './orderCounters';

const appReducer = combineReducers({
  activity: activitySlice.reducer,
  activities: activitiesSlice.reducer,
  customer: customerSlice.reducer,
  customers: customersSlice.reducer,
  globalErrors: globalErrorsSlice.reducer,
  order: orderSlice.reducer,
  orders: ordersSlice.reducer,
  orderCounter: orderCounterSlice.reducer,
  orderCounters: orderCountersSlice.reducer,
  job: jobSlice.reducer,
  jobs: jobsSlice.reducer,
  resource: resourceSlice.reducer,
  resources: resourcesSlice.reducer,
  resourceSkill: resourceSkillSlice.reducer,
  resourceSkills: resourceSkillsSlice.reducer,
  scheduledValue: scheduledValueSlice.reducer,
  scheduledValues: scheduledValuesSlice.reducer,
  skill: skillSlice.reducer,
  skills: skillsSlice.reducer,
  supplier: supplierSlice.reducer,
  suppliers: suppliersSlice.reducer,
  timesheet: timesheetSlice.reducer,
  timesheets: timesheetsSlice.reducer,
  timesheetLock: timesheetLockSlice.reducer,
  timesheetLocks: timesheetLocksSlice.reducer,
  typeOfPayment: typeOfPaymentSlice.reducer,
  typeOfPayments: typeOfPaymentsSlice.reducer,
  user: userSlice.reducer,
  users: usersSlice.reducer,
});

const rootReducer = (state: any, action: UnknownAction) => {
  //"store/reset" action set all the store to their initial value
  if (action.type === 'store/reset') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
